export { supabase } from './supabase';

export function formatApiError(error) {
  if (error == null) return 'Something went wrong. Please try again.';
  if (typeof error === 'string') return error;
  if (typeof error.message === 'string') return error.message;
  return String(error);
}
